
import { Mapper } from "../../../core/base";
import { Tenant } from "../../../core/domain/models/tenant";
import { TenantWebEntity } from "./tenant.web-entity";

export class TenantWebRepositoryMapper extends Mapper<TenantWebEntity, Tenant> {
    mapFrom(param: TenantWebEntity): Tenant {
      return {
        id: param.id,
        name: param.name,
        timeZone: param.timeZone,
        offSet: param.offSet,
        locale: param.locale,
        sequenceFactor : param.sequenceFactor
      };
    }
  
    mapTo(param: Tenant): TenantWebEntity {
      return {
        id: param.id,
        name: param.name,
        timeZone: param.timeZone,
        offSet: param.offSet,
        locale: param.locale,
        sequenceFactor : param.sequenceFactor
      };
    }
  
  }